import { useState } from 'react';
import './App.scss';
// import AlertPopup from "../src/Components/Global_Components/Popup/alert";
import { useSelector } from 'react-redux';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import CircularIndeterminate from '../src/Components/Global_Components/loader/progressloader';
import ActionAlerts from '../src/Components/Global_Components/popupalert/popupalert';
import SideBar from '../src/Components/Sidenav';
import Navbar from './Components/Navbar';
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import PrivateRoutes from './Pages/Login/Privaterouters';
import PatientView from './Pages/patientsView';
// import { admincreate } from "./Context/apiData";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/js/bootstrap.js';
import 'font-awesome/css/font-awesome.min.css';
import 'rsuite/dist/rsuite.css';
import AddFertility from './Components/AddFertility';
import BillGenerate from './Components/BillGenerate';
import DIFReport from './Components/DIFReport';
import IUIReport from './Components/IUIReport';
import SemenAnalysis from './Components/SemenAnalysis';
import SemenFreezing from './Components/SemenFreezing';
import PrescriptionShare from './Components/Share/PrescriptionShare';
import DeliveryAdmissionForm from './Components/Template_page/DeliveryAdmissionForm';
import DeliveryEssentials from './Components/Template_page/deliveryessentials';
import LayoutInPatient from './Layout/LayoutInPatient';
import BillReportDetails from './Pages/BillReportDetails';
import Charts from './Pages/Charts';
import ConsultationReport from './Pages/ConsultationReport';
import CreateUser from './Pages/CreateUser';
import DrugInventory from './Pages/DrugInventory/DrugInventory';
import Dashboard from './Pages/Fertility/chart/Dashboard';
import Fertility from './Pages/Fertility/Fertility';
import FertilityView from './Pages/Fertility/FertilityView';
import InjectionReport from './Pages/InjectionReport';
import InPatientSchedule from './Pages/InPatientSchedule/InPatientSchedule';
import View from './Pages/InPatientSchedule/View';
import OtReport from './Pages/OtReport';
import Patents from './Pages/Patents';
import Appointment from './Pages/Appointment/Appointment';
import PatientBilling from './Pages/PatientBilling';
import PatientReports from './Pages/PatientReports';
import PatientTemplates from './Pages/Patienttemplates';
import PharmacyReport from './Pages/PharmacyReport';
import Prescription from './Pages/Prescription';
import Embryologist from './Pages/Embryologist/Embryologist';
import IPBilling from './Pages/IPBilling/IPBilling';
import DischargeSummary from './Pages/DischargeSummary/DischargeSummary';
import ProcedureReport from './Pages/ProcedureReport';
import ReportView from './Pages/ReportView';
import ScanReport from './Pages/ScanReport';
import ViewPatientReport from './Pages/ViewPatientReport';
import ViewPrescriptionHistory from './Pages/viewPrescriptionHistory';

function App() {
  const Error = useNavigate();
  const loaderdata = useSelector(state => state.counter.loader);
  const popup = useSelector(state => state.counter.popupalert);
  const [alertpopuptext, setalertpopuptext] = useState('');
  const [loader, setLoader] = useState(loaderdata);
  const location = useLocation();
  const isShareUrl = location.pathname.includes('/share/');
  const [alertpopup, setalertpopup] = useState(popup);
  const [errorstatus, seterrorstatus] = useState('');
  var logintest = localStorage.getItem('login');
  const loaderchange = arg => {
    setLoader(arg);
  };
  const popupalert = arg => {
    setalertpopup(arg);
  };
  const popuptext = arg => {
    setalertpopuptext(arg);
  };

  return (
    <div className='App'>
      {loader == 'true' ? (
        <div
          className='loader'
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            zIndex: '999'
          }}>
          <CircularIndeterminate />
        </div>
      ) : (
        ''
      )}

      {alertpopup == 'true' ? <ActionAlerts alertpopuptext={alertpopuptext} popupalert={popupalert} /> : ''}

      <>
        {logintest == 'false' ? (
          <>
            {!isShareUrl && (
              <>
                <Navbar popupalert={popupalert} popuptext={popuptext} />
                <SideBar />
              </>
            )}
            <Routes>
              <Route path='/' element={<Home loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/patienttemplates' element={<PatientTemplates loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/Patients' element={<Patents loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/PatientView' element={<PatientView loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/prescription' element={<Prescription loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/charts' element={<Charts loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/charts/:type' element={<Charts loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />

              <Route path='/viewHistory' element={<ViewPrescriptionHistory loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/patient_billing' element={<PatientBilling loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/appointment' element={<Appointment />} />
              <Route path='/appointment/*' element={<Appointment />} />
              <Route path='/druginventory' element={<DrugInventory loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/inpatient' element={<LayoutInPatient />}>
                <Route index element={<InPatientSchedule loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='view' element={<View loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              </Route>
              <Route path='/fertility' element={<LayoutInPatient />}>
                <Route index element={<Fertility loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='add' element={<AddFertility loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='view' element={<FertilityView loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
                <Route path='analytics' element={<Dashboard loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              </Route>
              <Route path='/embryologist' element={<Embryologist />} />
              <Route path='/embryologist/*' element={<Embryologist />} />
              <Route path='/ipbilling' element={<IPBilling />} />
              <Route path='/ipbilling/*' element={<IPBilling />} />
              <Route path='/discharge-summary' element={<DischargeSummary />} />
              <Route path='/discharge-summary/*' element={<DischargeSummary />} />
              <Route path='/user_list' element={<CreateUser loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/bill_create' element={<BillGenerate loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/reportview' element={<ViewPatientReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/share/:id' element={<PrescriptionShare loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />

              {/*----templates---*/}
              <Route path='/patientreports' element={<PatientReports loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/reportcreate/SemenAnalysis' element={<SemenAnalysis loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/reportcreate/SemenFreezing' element={<SemenFreezing loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/reportcreate/dfi-report' element={<DIFReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/reportcreate/iui-report' element={<IUIReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
              <Route path='/reportcreate/deliveryadmissionform' element={<DeliveryAdmissionForm loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/reportcreate/deliveryessentials' element={<DeliveryEssentials loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/reportDetails/reportView' element={<ReportView loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/reportDetails' element={<BillReportDetails loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/reportDetails/pharmacy' element={<PharmacyReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/scan_report' element={<ScanReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/procedure_report' element={<ProcedureReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/consultation_report' element={<ConsultationReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/injection_report' element={<InjectionReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
              <Route path='/ot_report' element={<OtReport loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />}></Route>
            </Routes>
          </>
        ) : (
          <Routes>
            <Route element={<PrivateRoutes />} path='/' exact />
            {/* <Route
              path="/login"
              element={
                <Reportscreatepage
                  loaderchange={loaderchange}
                  popupalert={popupalert}
                  popuptext={popuptext}
                />
              }
            /> */}
            <Route path='/login' element={<Login loaderchange={loaderchange} popupalert={popupalert} popuptext={popuptext} />} />
          </Routes>
        )}
      </>
    </div>
  );
}

export default App;

